<script setup lang="ts">
interface Props {
  bottomOffset: number
}
interface Emits {
  (e: 'tapDetected', touchSide: 'right' | 'left'): void
}

defineProps<Props>()
const emit = defineEmits<Emits>()

const TOUCH_MOVE_THRESHOLD = 10

const DEFAULT_START_POS = {
  x: 0,
  y: 0,
}

let startPos = DEFAULT_START_POS

function handlePointerDown(e: PointerEvent) {
  e.preventDefault()
  startPos = {
    x: e.clientX,
    y: e.clientY,
  }
}

function handlePointerUp(e: PointerEvent) {
  e.preventDefault()
  const endX = e.clientX
  const endY = e.clientY

  if (Math.abs(endX - startPos.x) < TOUCH_MOVE_THRESHOLD && Math.abs(endY - startPos.y) < TOUCH_MOVE_THRESHOLD) {
    const screenWidth = window.innerWidth
    const touchSide = endX > screenWidth / 2 ? 'right' : 'left'
    emit('tapDetected', touchSide)
  }
  startPos = DEFAULT_START_POS
}
</script>

<template>
  <div
    class="w-full h-full"
    @pointerdown="handlePointerDown"
    @pointerup="handlePointerUp"
  >
    <slot />
  </div>
</template>
